// Shared helper for storing errors that need to re-render in the user's
// current language when they toggle PL/EN.
//
// Problem: `setError(t("some.key"))` caches the *evaluated* string at the
// moment of the error. Switching language afterwards re-renders the
// component with a new `t` but the state still holds the old string.
//
// Solution: store an *error descriptor* — never the evaluated string —
// and pass it through `renderError(info, t)` at render time. The
// descriptor is one of:
//   { key: "i18n.key" }            → t(key)
//   { err, context }               → formatPortalError(err, t, context)
//   { text: "literal" }            → as-is (e.g. server detail we trust)
//   null / undefined               → null
import { formatPortalError } from "./portalErrors";

export function renderError(info, t) {
  if (!info) return null;
  if (typeof info === "string") return info; // legacy callsites
  if (info.key) return t(info.key);
  if (info.err) return formatPortalError(info.err, t, info.context);
  if (info.text) return info.text;
  return t("portal.errors.generic");
}
